const FULL_DEVICES_LOAD = "full-device::load";
const FULL_DEVICES_LOAD_FAILURE = "full-device::load:failure";
const FULL_DEVICES_LOAD_SUCCESS = "full-device::load:success";
const FULL_DEVICES_UNLOAD = "full-device::unload";

const fullDevicesUnloadAction = {
  type: FULL_DEVICES_UNLOAD,
};

function fullDevicesLoadAction(config) {
  const { serviceArgs, resolve, reject } = config;
  const { params, options } = serviceArgs;

  return {
    payload: {
      reject,
      resolve,
      serviceArgs: [params, options],
    },
    type: FULL_DEVICES_LOAD,
  };
}

export {
  FULL_DEVICES_LOAD,
  FULL_DEVICES_LOAD_FAILURE,
  FULL_DEVICES_LOAD_SUCCESS,
  FULL_DEVICES_UNLOAD,
  fullDevicesLoadAction,
  fullDevicesUnloadAction,
};
